import axios from 'axios';

export const unsplash = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID Ktj2K2o_kib8z5r3XSiacJ0V38KXqnfARaD4UbZJ9P8'
  }
});
export const unsplash2 = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID 8hZbjCUvzv21J8LQHZ9Hr8TW4tNkz3aHoqLcudbmUvA'
  }
});
export const unsplash3 = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID iBKYoefBmTdNNjQo1Mp4f_9ud854QQXAlr0yPNU06RA'
  }
});
export const unsplash4 = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID cbd3c7b8a8bb9412b5dfa4a2adb6b82460b64ff5a574765b09214710e7552034'
  }
});


/*
 * fetch random photos
*/
export const unsplash_fetchRandomPhotos = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID 3rCNuzvpbayD7Jw8LKuDKpyvkQX-ZYxSSQRpAqCvlT4'
  }
});
export const unsplash_fetchRandomPhotos2 = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID CtGu808pyLL-QuqxhKF-87twolDBH_mjTisdI1TDPYU'
  }
});
export const unsplash_fetchRandomPhotos3 = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID uJFRbObV0qrCqKs3BMiZWTPKPHraeeJLFJxQ-mkekOs'
  }
});
export const unsplash_fetchRandomPhotos4 = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID F8pYMJX24sjvOVWinRekG2OdP5ToxLjHQbniSLEsVY8'
  }
});
export const unsplash_fetchRandomPhotos5 = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID pl_OsONqkPknZbBrajW1p2EZ0sHYbZ45YRwcuELfty8'
  }
});


/*
 * fetch one random photo
*/
export const unsplash_oneRandom = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID 0ed78b1bad9cd1a46c859a84e0bdcb37efc830bd76fa6a011c705699a9a09344'
  }
});
export const unsplash_oneRandom2 = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID 85e6b0cdc2f18723258515fe0f524e8544f8d0d11ff001c9dc42dd08df18562d'
  }
});


/*
 * fetch User
*/
export const unsplash_fetchUser = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID z0oVpNXUmYgePoi3IGVkjCwTejmxFyAsENNcCTnMKgg'
  }
});
export const unsplash_fetchUser2 = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID _gRjCDwA6JAllEtqSkSiWrOKdmrwJlZTnALGOPslado'
  }
});
export const unsplash_fetchUser3 = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID WfThtOubeFKaQSGcUslIkPj-QbSB9JRi1jtfQ2ZB2Yk'
  }
});
export const unsplash_fetchUser4 = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID Lb6jKzMy2aRnoZG1T-qjl9368gI14S21PhBCCY6l2lw'
  }
});
export const unsplash_fetchUser5 = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID pkRjrNFeqVWQLxv-wvzlnekOudzGw3O6AJVqzdit_G8'
  }
});


/*
 * fetch User photos
*/
export const unsplash_fetchPhotos = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID fimSYBe6sHQk2jqVrmdkbBovzMtZErqcd4CDMB8PDAM'
  }
});
export const unsplash_fetchPhotos2 = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID RfYhZWOBwmAgQ96WJOtsQ_Gh1hYy7l4Kot77CoNaXHM'
  }
});
export const unsplash_fetchPhotos3 = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID pxfYqeuoypji1mNSxfjG1crz3cHqsyWC8VOQHmqEjT8'
  }
});
export const unsplash_fetchPhotos4 = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID bc96bcfc5a7a49f0985ff7aea4b0d50b5c9ef7cc064e2639c21fbdb4723136f1'
  }
});
export const unsplash_fetchPhotos5 = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID d68c89a9a90d3eb74b9e9a527540e9651c190aa8a82487fd3b92f1e6ad86ade0'
  }
});


/*
 * fetch User liked photos
*/
export const unsplash_userLikedPhotos = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID _3To1VPYs0eOsOaUrX8e7NMwinv-nhBklEZOoUUYyQU'
  }
});
export const unsplash_userLikedPhotos2 = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID MjouIFO4PvRE5F3Qxc894T3SuCRmm6MLK0NfFj4ecnY'
  }
});
export const unsplash_userLikedPhotos3 = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID 8Yl5SjBjhrgbymOxkkMq_POygmHulEciNqVNHPXg6Qo'
  }
});
export const unsplash_userLikedPhotos4 = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID c9eaf30feaa3a9cc483a8901c842d0a4378fea42366464cd941cef6a55bb8f7a'
  }
});
export const unsplash_userLikedPhotos5 = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID a1f5a5b05ee307d50f9fc59c9e3714e4bc5b1bf04889f51af4a9a5e1436606f2'
  }
});


/*
 * fetch User collections
*/
export const unsplash_userCollections = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID zqB3sZbE1AU4ULEin-8znK9CL39VHgmKZqU03cDyyJM'
  }
});
export const unsplash_userCollections2 = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID JdFmW6FRYkD6onqIYTQj6A40TLSISs6Z5TQR1XQBZ5Q'
  }
});
export const unsplash_userCollections3 = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID mb6DOsqfT54FIeetoKLcbUlQhWmifS31fvDlh7Nzq48'
  }
});
export const unsplash_userCollections4 = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID 056f8c437f3e19be30ed277d41cc684b82766428cac74d901e086e1f835153d3'
  }
});
export const unsplash_userCollections5 = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID f9a15d722caa03e2aa0e380c08efe7c687a4bb3028bec517979cc271bab9e491'
  }
});


/*
 * fetch User collection photos
*/
export const unsplash_userCollectionPhotos = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID SlrM5ABxSNJmYzpPwAiE-JiE7_CFzqkvPousedTfhEQ'
  }
});
export const unsplash_userCollectionPhotos2 = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID 5uG5vCbI959SIqluzHfh4lkKxr2viJ6HVF7mXKrwNww'
  }
});
export const unsplash_userCollectionPhotos3 = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID G6KuLShyM3OeduPXvmOA4-QoyRXty7sqX2jw_vViLLM'
  }
});
export const unsplash_userCollectionPhotos4 = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID 9f70c805ca64f2d39557ebb52251f02c6e8c62b4908f312549a0e89389d5724c'
  }
});
export const unsplash_userCollectionPhotos5 = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID 6f43bdf5549fd630f86105a22ec20ce56e71c2f229dbf2261788ec76270246cd'
  }
});


/*
 * fetch User collection id
*/
export const unsplash_userCollectionId = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID dKa7C7XVSuSGCSHQ-VM2gfBo7R8XqaoTu83HirBw0qk'
  }
});
export const unsplash_userCollectionId2 = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID AmTcvi3pMvlSSmli9-1cpucRNbjivFUpeL0UnXYY69c'
  }
});
export const unsplash_userCollectionId3 = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID 9SvPL8fXm9fE5P7ZQLfu1D5KKE6DMiWDQ_jDdfSX2Tw'
  }
});
export const unsplash_userCollectionId4 = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID Omgcb658U6Gfc8k7MSFxqwG-HeWS33JMYfqEkHyURRM'
  }
});
export const unsplash_userCollectionId5 = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID 9slz2iejyTNcz9vaK9D3hDWr2Ri1T87f04ujm-XpLEY'
  }
});


/*
 * 403 callback
*/
export const unsplashStatus = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID 390f5dac0caf9fd175779018662958b44539a6dc301ca8210e17316eb3612ec6'
  }
});
export const unsplashStatus2 = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID 14d1ee217124a7ff55bfafaa2df3d49640ef1aa6510262875fcbb564129837a9'
  }
});
